import { useTranslation } from 'react-i18next';

import { Button } from '@saas-kit/ui';

import type { AdminInvoice } from './types';

interface Props {
  invoice: AdminInvoice;
  canIssue: boolean;
  canMarkPaid: boolean;
  canVoid: boolean;
  canRecordPayment: boolean;
  issuePending: boolean;
  markPaidPending: boolean;
  voidPending: boolean;
  onIssue: () => void;
  onMarkPaid: () => void;
  onVoid: () => void;
  onRecordPayment: () => void;
}

export function InvoiceActionsFooter({
  canIssue,
  canMarkPaid,
  canVoid,
  canRecordPayment,
  issuePending,
  markPaidPending,
  voidPending,
  onIssue,
  onMarkPaid,
  onVoid,
  onRecordPayment,
}: Props): JSX.Element {
  const { t } = useTranslation('adminBilling');
  return (
    <div className="flex flex-wrap justify-end gap-2">
      {canIssue ? (
        <Button variant="secondary" disabled={issuePending} onClick={onIssue}>
          {t('detail.actions.issue')}
        </Button>
      ) : null}
      {canRecordPayment ? (
        <Button variant="secondary" onClick={onRecordPayment}>
          {t('detail.actions.record_payment')}
        </Button>
      ) : null}
      {canMarkPaid ? (
        <Button variant="secondary" disabled={markPaidPending} onClick={onMarkPaid}>
          {t('detail.actions.mark_paid')}
        </Button>
      ) : null}
      {canVoid ? (
        <Button variant="destructive" disabled={voidPending} onClick={onVoid}>
          {t('detail.actions.void')}
        </Button>
      ) : null}
    </div>
  );
}
